import * as React from "react"
import { useDispatch } from "react-redux"
import { useAuth } from "@kiwicom/nitro/lib/services/auth/context"

import { setState } from "../../../../services/auth"

const SyncStore = () => {
  const dispatch = useDispatch()
  const auth = useAuth()

  React.useEffect(() => {
    dispatch(setState(auth))
  }, [dispatch, auth])

  return null
}

export default SyncStore
